import axios from 'axios'
import React, { useEffect, useState } from 'react'
import classes from './Game.module.css';
import { Link } from 'react-router-dom';
import BrainIcon from '../../icons/BrainIcon';
import BookIcon from '../../icons/BookIcon';
import GameIcon from '../../icons/GameIcon';

const Game = ({tgUserId, ...props}) => {

   const baseUrl = process.env.REACT_APP_API_URL ;

   const [data, setData] = useState();

   useEffect(()=>{
      axios.get(baseUrl+"/appi/quiz/infopanel/"+tgUserId).then((response)=>{
         setData(response.data);
         console.log(response.data);
      })
      .catch((error) => {
         console.error(error);
      })
   },[])
  
  return (
    <div>

         <div className={classes.header}>
            {data?.is_student === 'true' ? 
               <svg className={classes.icon_student} xmlns="http://www.w3.org/2000/svg" height="44px" viewBox="0 -960 960 960" width="44px" fill="#75FB4C"><path d="M480-120 200-272v-240L40-600l440-240 440 240v320h-80v-276l-80 44v240L480-120Zm0-332 274-148-274-148-274 148 274 148Zm0 241 200-108v-151L480-360 280-470v151l200 108Zm0-241Zm0 90Zm0 0Z"/>
               </svg>:
               <svg className={classes.icon_student} xmlns="http://www.w3.org/2000/svg" height="44px" viewBox="0 -960 960 960" width="44px" fill="#75FB4C"><path d="M234-176.5q-23.72 0-40.61-16.89T176.5-234v-492q0-23.72 16.89-40.61T234-783.5h492q23.72 0 40.61 16.89T783.5-726v492q0 23.72-16.89 40.61T726-176.5H234Zm0-25.5h492q14 0 23-9t9-23v-444H202v444q0 14 9 23t23 9Zm246-130.5q-59.61 0-107.81-30-48.19-30-74.69-77.5 26.5-47.5 74.69-77.5 48.2-30 107.81-30t107.81 30q48.19 30 74.69 77.5-26.5 47.5-74.69 77.5-48.2 30-107.81 30Zm.09-27q44.91 0 84.66-21.27t68.75-59.25q-29-37.98-68.84-59.23t-84.75-21.25q-44.91 0-84.66 21.27t-68.75 59.25q29 37.98 68.84 59.23t84.75 21.25ZM480-440Zm.12 38q15.88 0 27.13-11.12 11.25-11.12 11.25-27t-11.46-27.13q-11.45-11.25-27.33-11.25-15.89 0-26.8 11.46Q442-455.59 442-439.71q0 15.89 11.12 26.8t27 10.91Z"/>
               </svg>

            }
            <div className={classes.convs_relativity}>
               <p className={classes.convs_relativity_text}>Виконано: </p> 
               <p className={`${classes.convs_relativity_text} 
               ${ (( data?.finished_tests < data?.all_tests ) ?  (classes.text_finished_less) : (classes.text_all) ) } `}>
               {data?.finished_tests}</p>
               <p className={classes.convs_relativity_text} style={{color:'gray'}}>/</p>
               <p className={`${classes.convs_relativity_text}  ${classes.text_all}` }>{data?.all_tests}</p> 
               
            </div>
            
         </div>

            <div style={{ display:'flex', flexDirection:'column', justifyContent:'center'}}>
                  
                  {
                     data?.is_student === 'true' ? 
                     <Link to={`/tests/${tgUserId}`} className={classes.linkes} >
                     <div className={classes.link_wrapper} >
                        <BrainIcon className={classes.icon_test} />
                        <p className={classes.text_test}>
                           Закріплення знаннь
                        </p>
                        
                     </div>
                     </Link>
                  : ''
                  }
                  <Link to={`/public-tests/${tgUserId}`} className={classes.linkes} >
                     <div className={classes.link_wrapper} >
                        <BrainIcon className={classes.icon_quizes} />
                        <p className={classes.text_test}>
                          Загальні Квізи
                        </p>
                        
                     </div>
                  </Link>
                  <Link style={{filter:'blur(4px)'}} className={classes.linkes} >
                     <div className={classes.link_wrapper} >
                        <BookIcon className={classes.icon_book} />
                        <p className={classes.text_test}>
                           Мої слова
                        </p>
                        
                     </div>
                  </Link>
                  <Link style={{filter:'blur(4px)'}}  className={classes.linkes} >
                     <div className={classes.link_wrapper} >
                        <GameIcon className={classes.icon_game} />
                        <p className={classes.text_test}>
                           Ігри
                        </p>
                        
                     </div>
                  </Link>
            </div>
         
         
     
    </div>
  )
}
export default Game;